<template>
  <div ref="pageEl" class="page" @scroll="updateScrollPosition">
    <navbar-conference></navbar-conference>
    <div v-show="loader" class="loader disable"></div>
    <router-view></router-view>
    <footer-conference></footer-conference>
  </div>
</template>

<script>
import NavbarConference from "./NavbarConference";
import FooterConference from "./FooterConference";

export default {
  components: {
    "navbar-conference": NavbarConference,
    "footer-conference": FooterConference,
  },
  data() {
    return {
      scrollPosition: 0
    };
  },
  computed: {
    loader() {
      return this.$store.state.loader;
    }
  },
  watch: {
    async $route() {
      this.$refs.pageEl.scrollTop = 0;
    },
  },
  methods: {
    updateScrollPosition() {
      this.scrollPosition = this.$refs.pageEl.scrollTop;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../css/otherWebVariables";

.page {
  height: 100%;
  overflow-y: scroll;
  background: $color-background;
  font-size: $font-16;
}

@media screen and (max-width: $m-size) {
  .page {
    height: 100%;
    overflow-x: hidden;
    background: $color-background;
    font-size: $font-16;
  }
}
</style>
